import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as Se, useState as ie, useRef as _e, useMemo as ce, useCallback as $e, Fragment as be, createElement as ae } from "react";
import { clsx as fe } from "../../../node_modules/clsx/dist/clsx.m.js";
import { useFloating as ze, useClick as Ae, useDismiss as Ee, useInteractions as We, FloatingFocusManager as Ge, FloatingPortal as Ue } from "../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import Je from "../../../node_modules/lodash/isArray.js";
import { i18n as me } from "../../../utils/locale/locale.js";
import Qe from "../../atoms/DatePicker/useOnClickOutside.js";
import xe from "../../atoms/Divider/Divider.js";
import Ve from "../../atoms/TextField/TextField.js";
import { Typography as ue } from "../../atoms/Typography/Typography.js";
import Xe from "../../atoms/Icon/Icon.js";
import he from "../../atoms/ListItem/ListItem.js";
import Ye from "../../atoms/Button/Button.js";
import Ze from "../../atoms/ScrollbarContainer/ScrollBarContainer.js";
import { useSlideTransition as qe } from "./components/useSlideTransition.js";
import B from "./Dropdown.module.scss.js";
import { DropdownContext as De } from "./DropdownContext.js";
import Oe from "../AvatarLabel/AvatarLabel.js";
import { l as Ke } from "../../../node_modules/lodash/lodash.js";
import { offset as er, flip as rr, shift as sr } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate as tr } from "../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
const nr = ({
  children: de,
  testId: b,
  mode: pe = "light",
  dropDownElement: z,
  position: je = "bottom-start",
  withPortal: we = !1,
  stopDismiss: d = !1,
  header: p,
  footer: A,
  options: f,
  isSearchable: C = !1,
  minItems: E = 1,
  maxItems: W = 4,
  size: G = "compact",
  labelKey: j = "text",
  valueKey: U = "value",
  subLabelKey: w = "helperText",
  avatarSrcKey: J = "avatarSrc",
  groupKey: I = "group_label",
  readOnly: Q = !1,
  width: ge = "auto",
  offsetSize: ve = 10,
  loading: g = !1,
  searchDelay: S = 0,
  onScrollEnd: _,
  onClose: i,
  onClickListItem: $,
  onSearchChange: V
}) => {
  var q;
  const [m, v] = ie(!1), [c, Fe] = ie(""), X = _e(null);
  Qe(X, () => {
    d || v(!1), i == null || i();
  });
  const { refs: Y, floatingStyles: Le, context: F } = ze({
    open: m,
    placement: je,
    middleware: [er(ve), rr(), sr({ padding: 10 })],
    whileElementsMounted: tr
  }), Ne = Ae(F), ye = Ee(F, {
    enabled: !d
  }), { getReferenceProps: ke, getFloatingProps: Te } = We([Ne, ye]), { isMounted: He, styles: Me } = qe(F), Pe = fe(B.dropdownContainer, B[pe]), Re = ce(() => g ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: "flex flex-col justify-center items-center w-full h-full absolute top-0 left-0 bg-base-colors-white-700 z-[1005]",
      style: {
        minHeight: E * 44,
        maxHeight: W * 44,
        top: 0 + (C ? 45 : 0) + (p ? 57 : 0)
      },
      "data-testid": "dropdown-loader",
      children: /* @__PURE__ */ e.jsx("div", { className: B.loader })
    }
  ) : null, [g, C, p]), l = ce(() => c && S === 0 ? f == null ? void 0 : f.map((r) => {
    var a, s, u, D, L, O, N, K, y, ee, k, re, T, se;
    const o = r, t = (D = (u = (s = (a = o == null ? void 0 : o[I]) == null ? void 0 : a.toLowerCase) == null ? void 0 : s.call(a)) == null ? void 0 : u.includes) == null ? void 0 : D.call(u, c.toLowerCase()), x = (O = (L = o.options) == null ? void 0 : L.filter) == null ? void 0 : O.call(
      L,
      (h) => {
        var H, te, M, ne, P, le, R, oe;
        return ((ne = (M = (te = (H = h == null ? void 0 : h[w]) == null ? void 0 : H.toLowerCase) == null ? void 0 : te.call(H)) == null ? void 0 : M.includes) == null ? void 0 : ne.call(M, c.toLowerCase())) || ((oe = (R = (le = (P = h == null ? void 0 : h[j]) == null ? void 0 : P.toLowerCase) == null ? void 0 : le.call(P)) == null ? void 0 : R.includes) == null ? void 0 : oe.call(R, c.toLowerCase()));
      }
    );
    if (t || x && x.length > 0)
      return {
        ...o,
        // include all items if group matches else show only filtered items
        options: t ? o.options : x
      };
    const n = r;
    return (ee = (y = (K = (N = n == null ? void 0 : n[w]) == null ? void 0 : N.toLowerCase) == null ? void 0 : K.call(N)) == null ? void 0 : y.includes) != null && ee.call(y, c.toLowerCase()) || (se = (T = (re = (k = n == null ? void 0 : n[j]) == null ? void 0 : k.toLowerCase) == null ? void 0 : re.call(k)) == null ? void 0 : T.includes) != null && se.call(T, c.toLowerCase()) ? n : null;
  }).filter(Boolean) : f, [c, S, f]), Be = (r, o) => {
    if (Q) {
      r.preventDefault();
      return;
    }
    $ == null || $(r, o), d || (v(!1), i == null || i());
  }, Ce = $e(
    (r) => {
      (r.key === " " || r.key === "Enter") && (r.preventDefault(), v(!m), m && !d && (i == null || i()));
    },
    [m, i, d]
  ), Ie = Ke.debounce((r) => {
    V && (Fe(r), V(r));
  }, S), Z = He && /* @__PURE__ */ e.jsx(
    "div",
    {
      ref: Y.setFloating,
      className: "h-fit z-[1006]",
      style: {
        ...Le,
        width: ge
      },
      ...Te(),
      children: /* @__PURE__ */ e.jsx(
        "ul",
        {
          role: "listbox",
          tabIndex: -1,
          "data-testid": "dropdown",
          style: Me,
          className: fe("shadow-m-mixed overflow-hidden", Pe),
          children: /* @__PURE__ */ e.jsx("div", { ref: X, children: /* @__PURE__ */ e.jsx(De.Provider, { value: { onClickListItem: Be }, children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            p && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(Oe, { ...p }),
              /* @__PURE__ */ e.jsx(xe, {})
            ] }),
            f && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              C && /* @__PURE__ */ e.jsx("div", { className: "px-150 py-075", children: /* @__PURE__ */ e.jsx(
                Ve,
                {
                  size: "compact",
                  leadingIcon: "search-sm",
                  placeholder: me("search"),
                  onChange: Ie,
                  testId: `${b}-search`
                }
              ) }),
              !(l != null && l.length) && !g && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-center items-center w-full h-full p-150 gap-150", children: [
                /* @__PURE__ */ e.jsx(
                  Xe,
                  {
                    name: "file-search-02",
                    className: "text-color-fg-lightest"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  ue,
                  {
                    text: me("no_results_found"),
                    variant: "interface/medium/sm",
                    textColor: "color/fg/lightest"
                  }
                )
              ] }),
              Re,
              (l == null ? void 0 : l.length) > 0 && /* @__PURE__ */ e.jsx(
                Ze,
                {
                  height: "auto",
                  maxHeight: W * 44,
                  minHeight: E * 44,
                  handleScrollEnd: () => !g && (_ == null ? void 0 : _()),
                  children: (q = l == null ? void 0 : l.map) == null ? void 0 : q.call(l, (r, o) => {
                    var x, n, a;
                    const t = r;
                    return Je(t == null ? void 0 : t.options) ? /* @__PURE__ */ e.jsxs(be, { children: [
                      ((x = t.options) == null ? void 0 : x.length) && (t == null ? void 0 : t[I]) && /* @__PURE__ */ e.jsx("div", { className: "px-200 py-100", children: /* @__PURE__ */ e.jsx(
                        ue,
                        {
                          text: t == null ? void 0 : t[I],
                          textColor: "color/fg/lighter",
                          variant: "interface/medium/s"
                        }
                      ) }),
                      (a = (n = t.options) == null ? void 0 : n.map) == null ? void 0 : a.call(n, (s, u) => /* @__PURE__ */ ae(
                        he,
                        {
                          ...s,
                          text: s == null ? void 0 : s[j],
                          helperText: s == null ? void 0 : s[w],
                          value: s == null ? void 0 : s[U],
                          avatarSrc: s == null ? void 0 : s[J],
                          key: u,
                          size: G
                        }
                      )),
                      /* @__PURE__ */ e.jsx(xe, {})
                    ] }, o) : /* @__PURE__ */ ae(
                      he,
                      {
                        ...r,
                        text: r == null ? void 0 : r[j],
                        helperText: r == null ? void 0 : r[w],
                        value: r == null ? void 0 : r[U],
                        avatarSrc: r == null ? void 0 : r[J],
                        key: `item-${o}`,
                        size: G
                      }
                    );
                  })
                }
              )
            ] }),
            de,
            A && /* @__PURE__ */ e.jsx("div", { className: "mx-150 my-075", children: /* @__PURE__ */ e.jsx(
              Ye,
              {
                variant: "outlined",
                color: "neutral",
                ...A,
                fullWidth: !0
              }
            ) })
          ] }) }) })
        }
      )
    }
  );
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: B.dropdownWrapper,
      "data-testid": b,
      children: [
        z && /* @__PURE__ */ e.jsx(
          "div",
          {
            ref: Y.setReference,
            ...ke(),
            onClick: (r) => {
              if (Q)
                return r.preventDefault();
              v(!m);
            },
            "aria-haspopup": "menu",
            "aria-expanded": m ? "true" : "false",
            onKeyDown: Ce,
            role: "button",
            tabIndex: 0,
            children: z
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ge,
          {
            context: F,
            modal: !1,
            initialFocus: -1,
            children: /* @__PURE__ */ e.jsx(e.Fragment, { children: we ? /* @__PURE__ */ e.jsx(Ue, { children: Z }) : Z })
          }
        )
      ]
    }
  );
}, Tr = Se(nr);
export {
  nr as Dropdown,
  Tr as default
};
//# sourceMappingURL=Dropdown.js.map
